window.RB = window.RB || {};
(function () {
  const RB = window.RB;

  RB.useLocalArt = true;
  RB.artOverrides = {};

  RB.setArtOverrides = function (map) {
    const out = {};
    for (const ref in map || {}) {
      const c = RB.Setup && RB.Setup.findCard ? RB.Setup.findCard(ref) : null;
      out[c ? c.id : ref] = map[ref];
    }
    RB.artOverrides = out;
  };

  function localUrl(p) {
    if (!p) return p;
    const s = String(p);
    return s.charAt(0) === "/" || /^[a-z][a-z0-9+.-]*:/i.test(s) ? s : "/" + s;
  }
  RB.localUrl = localUrl;

  const placeholders = {};

  function xml(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function nameLines(name) {
    const words = String(name || "?").split(/\s+/);
    if (words.length < 2) return words;
    const mid = Math.ceil(words.length / 2);
    return [words.slice(0, mid).join(" "), words.slice(mid).join(" ")];
  }

  function artPlaceholder(c) {
    const name = (c && c.name) || "?";
    const kind = ((c && c.types) || [])[0] || "token";
    const key = name + "|" + kind;
    if (placeholders[key]) return placeholders[key];
    const lines = nameLines(name);
    const y0 = lines.length > 1 ? 560 : 620;
    let text = "";
    for (let i = 0; i < lines.length; i++) {
      text += "<text x='372' y='" + (y0 + i * 96) + "' text-anchor='middle' font-family='Georgia,serif'" +
        " font-size='84' font-weight='700' fill='#f0dcae'>" + xml(lines[i]) + "</text>";
    }
    const svg =
      "<svg xmlns='http://www.w3.org/2000/svg' width='744' height='1039' viewBox='0 0 744 1039'>" +
      "<defs><radialGradient id='g' cx='50%' cy='38%' r='72%'>" +
      "<stop offset='0' stop-color='#3a4256'/><stop offset='1' stop-color='#12151f'/>" +
      "</radialGradient></defs>" +
      "<rect width='744' height='1039' fill='url(#g)'/>" +
      "<rect x='22' y='22' width='700' height='995' rx='34' fill='none' stroke='#c9a34f' stroke-width='7' opacity='0.75'/>" +
      "<g transform='translate(372 330) scale(11)' fill='none' stroke='#c9a34f' stroke-width='1.2' opacity='0.85'>" +
      "<path d='M0 -10l8.7 5v10L0 10l-8.7-5V-5z'/><circle cx='0' cy='0' r='3.4'/>" +
      "</g>" + text +
      "<text x='372' y='880' text-anchor='middle' font-family='Georgia,serif' font-size='44'" +
      " letter-spacing='10' fill='#8d9bb5'>" + xml(kind.toUpperCase()) + " TOKEN</text>" +
      "</svg>";
    placeholders[key] = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
    return placeholders[key];
  }

  const TOKEN_ART_SOURCES = { Recruit: "Recruit (DE)" };
  const tokenArt = {};

  RB.artCard = function (c) {
    if (!c || !c.token || c.image) return c;
    const name = c.name;
    if (tokenArt[name] === undefined) {
      const want = TOKEN_ART_SOURCES[name] || name;
      const src = (window.CARD_DB || []).find(function (d) { return d.name === want && d.image; });
      tokenArt[name] = src ? Object.assign({}, c, { id: src.id, image: src.image, image_cdn: src.image_cdn }) : null;
    }
    return tokenArt[name] || c;
  };

  RB.hasArt = function (c) { return !!(c && RB.artCard(c).image); };

  RB.art = function (c) {
    c = RB.artCard(c);
    if (!c) return "";
    if (c.id && RB.artOverrides[c.id]) return localUrl(RB.artOverrides[c.id]);
    if (RB.useLocalArt && c.image) return localUrl(c.image);
    return c.image_cdn || localUrl(c.image) || artPlaceholder(c);
  };

  RB.ANIMATED = {
    "ogn-148-298": true, "ogs-001-024": true, "ogs-009-024": true,
    "sfd-177-221": true, "ven-183-166": true, "ven-sp3-006": true,
  };

  RB.CINEMATICS = {
    "ogn-148-298": { clip: "img/cine/ogn-148-298", dur: 3000, fit: "contain", formats: ["webm"] },
  };

  RB.cinematicFor = function (c) {
    const e = c && c.id ? RB.CINEMATICS[c.id] : null;
    if (!e) return null;
    const sources = [];
    for (const ext of e.formats || ["webm", "mp4"]) sources.push(localUrl(e.clip + "." + ext));
    return {
      id: c.id,
      name: c.name,
      sources: e.clip ? sources : [],
      poster: e.poster ? localUrl(e.poster) : "",
      dur: e.dur || 2600,
      fit: e.fit || "contain",
      audio: !!e.audio,
      wait: e.wait || 1400,
      plate: e.plate,
    };
  };

  RB.VARIANTS = { sm: 224, md: 448, full: 744 };

  RB.hasAnimated = function (c) { c = RB.artCard(c); return !!(c && RB.ANIMATED[c.id]); };

  RB.artAnimated = function (c) {
    c = RB.artCard(c);
    if (!RB.hasAnimated(c) || !RB.useLocalArt) return RB.art(c);
    return localUrl(String(c.image).replace(/\.webp$/, "-anim.webp"));
  };

  function localBase(c) {
    c = RB.artCard(c);
    if (!c || !c.image) return "";
    if (c.id && RB.artOverrides[c.id]) return "";
    return RB.useLocalArt ? localUrl(String(c.image)) : "";
  }

  function artVariant(c, size, animated) {
    const base = localBase(c);
    if (!base) return RB.art(c);
    const anim = animated && RB.hasAnimated(c);
    if (size === "full") return anim ? RB.artAnimated(c) : base;
    return base.replace(/\.webp$/, (anim ? "-anim-" : "-") + size + ".webp");
  }

  RB.artSrcset = function (c, animated) {
    const base = localBase(c);
    if (!base) return "";
    const out = [];
    for (const size of ["sm", "md", "full"]) {
      out.push(artVariant(c, size, animated) + " " + RB.VARIANTS[size] + "w");
    }
    return out.join(", ");
  };

  function artSizeFor(cssWidth) {
    const need = (cssWidth || 0) * (window.devicePixelRatio || 1);
    return need <= RB.VARIANTS.sm ? "sm" : need <= RB.VARIANTS.md ? "md" : "full";
  }

  RB.artCssAt = function (c, cssWidth, animated) {
    const anim = animated === undefined ? RB.hasAnimated(c) : !!animated;
    const url = artVariant(c, artSizeFor(cssWidth), anim);
    return url ? "url('" + url + "')" : "";
  };

  RB.artSrc = function (img, c, sizes, animated) {
    const anim = animated === undefined ? RB.hasAnimated(c) : !!animated;
    const set = RB.artSrcset(c, anim);
    if (set) {
      img.sizes = sizes || "140px";
      img.srcset = set;
    }
    img.src = anim ? RB.artAnimated(c) : RB.art(c);
  };

  RB.artFallback = function (img, c, onGiveUp) {
    img.onerror = function () {
      if (img.srcset) {
        img.srcset = "";
        img.sizes = "";
        img.src = RB.art(c);
        return;
      }
      const cdn = RB.artCard(c) && RB.artCard(c).image_cdn;
      if (cdn && String(img.src).indexOf(cdn) < 0) {
        RB.useLocalArt = false;
        img.src = cdn;
        return;
      }
      img.onerror = null;
      if (onGiveUp) onGiveUp();
      else img.remove();
    };
  };

  const probe = window.CARD_ART_PROBE;
  if (probe && typeof Image === "function") {
    const test = new Image();
    test.onerror = function () {
      RB.useLocalArt = false;
      console.warn("[art] local card art missing - falling back to the CDN. Run: python scripts/fetch_images.py");
      if (window.UI && UI.render && window.APP && APP.state) UI.render();
      if (window.TBX && TBX.render) TBX.render();
    };
    test.src = localUrl(probe);
  }
})();
